import {
  exportAchievement,
  httpAchievementList,
  httpASyncAchievementDateWeekConfig,
  httpCompanyList,
  httpDictServ,
} from '@/services/customerServices'
import {fileConfirm} from '@/utils/common'
import {message} from 'antd'
import dayjs from 'dayjs'

/**
 * 获取数据字典并复制给Ref
 * @param category - 目录Ref
 * @returns {Promise}
 */
export const getCategoryFn = (category: { current: any }): Promise<any> => {
  return new Promise(async resolve => {
    const resData: any = await httpDictServ({ parentKey: 'performanceType', enable: 1 })
    category.current = resData
    resolve(resData)
  })
}

/** 获取门店列表 */
export const getCompanyFn = (compony: { current: any }): Promise<any> => {
  return new Promise(async resolve => {
    const companyList: any = await httpCompanyList()
    // let companyTree: any[] = [{ title: '全部门店', val: [], key: '0-0', child: [] }]
    // if (companyList.length) {
    //   for (let i = 0; i < companyList.length; i++) {
    //     companyList[i].title = companyList[i].companyName
    //     companyList[i].val = companyList[i].orgId + ''
    //     companyList[i].key = companyList[i].val
    //     companyTree[0].val.push(companyList[i].val)
    //     companyTree[0].child.push(companyList[i])
    //   }
    // }
    compony.current = companyList
    resolve(companyList)
  })
}

/**
 * 同步周次配置
 * @param record - table row数据集合
 */
export const onWeekEditFn = async (record: any) => {
  try {
    const resData = await httpASyncAchievementDateWeekConfig(record.id)
    message.success(resData.message || '操作成功', 6)
  } catch (error) {
    message.error('失败')
  }
}

/**
 * 导出
 * @param {object} values - 导出需要传递的参数
 */
export const onExportFn = (values: { [key: string]: any }) => {
  const { companyIds, yearMonth, _category, productionType } = values
  const params =
    '?companyIds=' +
    (companyIds && companyIds.length ? companyIds : '') +
    '&yearMonth=' +
    (yearMonth ? yearMonth : '') +
    '&category=' +
    (_category ? _category : '') +
    '&productionType=' +
    (productionType ? productionType : '')
  message.loading({ content: '导出中' })
  exportAchievement(params)
    .then((res: any) => {
      fileConfirm()
    })
    .catch(error => {
      console.log(error)
    })
}

/**
 * 表格统一请求
 * @param values - 表单数据
 * @returns
 */
export const fetchList = (values: any) => {
  return new Promise((resolve, reject) => {
    try {
      const { current, pageSize, query } = values
      const newObj = {
        ...query,
        yearMonth: query.yearMonth ? dayjs(query.yearMonth).format('YYYY-MM') : '',
      }
      httpAchievementList(current, pageSize, newObj).then(data => resolve(data))
    } catch {
      reject({ success: false })
    }
  })
}
